import { tv } from 'tailwind-variants'

export const columns = tv({
  base: 'flex flex-row',
  variants: {
    collapseOnMobile: {
      true: 'flex-col md:flex-row',
    },
    space: {
      none: 'gap-x-0',
      xxsmall: 'gap-x-1',
      mini: 'gap-x-2',
      xsmall: 'gap-x-2.5',
      small: 'gap-x-4',
      medium: 'gap-x-5',
      gutter: 'gap-x-6',
      large: 'gap-x-8',
      largeMedium: 'gap-x-10',
      xlarge: 'gap-x-12',
      xlargeMedium: 'gap-x-16',
      xxlarge: 'gap-x-20',
      xxlargeMedium: 'gap-x-28',
      xxxlarge: 'gap-x-40',
    },
    collapsedSpace: {
      none: 'gap-y-0',
      xxsmall: 'gap-y-1',
      mini: 'gap-y-2',
      xsmall: 'gap-y-2.5',
      small: 'gap-y-4',
      medium: 'gap-y-5',
      gutter: 'gap-y-6',
      large: 'gap-y-8',
      largeMedium: 'gap-y-10',
      xlarge: 'gap-y-12',
      xlargeMedium: 'gap-y-16',
      xxlarge: 'gap-y-20',
      xxlargeMedium: 'gap-y-28',
      xxxlarge: 'gap-y-40',
    },
  },
})
